/**
 * MT Custom Header Scroll Behavior
 * 实现滚动时导航栏隐藏/显示功能
 * 并覆盖搜索功能：使用下拉框而不是抽屉
 */
(function() {
  'use strict';

  function initCustomHeaderSearch() {
    const headers = document.querySelectorAll('[id^="MtCustomHeader-"]');
    headers.forEach(function(header) {
      const searchBtn = header.querySelector('.mt-mega-header__action-btn--search');
      const drawer = header.querySelector('[data-search-drawer]');
      if (!searchBtn || !drawer) return;

      const overlay = drawer.querySelector('.mt-mega-header__search-drawer-overlay');
      const closeBtns = drawer.querySelectorAll('[data-search-drawer-close]');
      const panel = drawer.querySelector('.mt-mega-header__search-drawer-panel');
      let onDocumentPointerDown = null;

      function openDrawer() {
        if (!drawer) return;
        drawer.hidden = false;
        requestAnimationFrame(function() {
          drawer.classList.add('is-open');
        });
        const input = drawer.querySelector('.mt-mega-header__search-input');
        if (input) {
          setTimeout(function() {
            input.focus();
          }, 150);
        }
        document.body.classList.add('overflow-hidden');

        // 点击弹窗外空白处关闭（不依赖 overlay 是否覆盖到位）
        if (!onDocumentPointerDown) {
          onDocumentPointerDown = function (event) {
            if (!drawer.classList.contains('is-open')) return;
            const target = event.target;
            if (!target) return;

            // 点击按钮本身不算 outside
            if (searchBtn.contains(target)) return;
            // 点击面板内部不关闭
            if (panel && panel.contains(target)) return;
            // 点击抽屉容器内部（例如 overlay）也不在这里处理，交给原有 overlay 逻辑
            if (drawer.contains(target) && target !== document.documentElement && target !== document.body) {
              // overlay 点击会走 overlay listener；这里不重复关闭
              return;
            }
            closeDrawer();
          };
          document.addEventListener('pointerdown', onDocumentPointerDown, true);
        }
      }

      function closeDrawer() {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        setTimeout(function() {
          drawer.hidden = true;
        }, 250);
        document.body.classList.remove('overflow-hidden');

        if (onDocumentPointerDown) {
          document.removeEventListener('pointerdown', onDocumentPointerDown, true);
          onDocumentPointerDown = null;
        }
      }

      searchBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      }, true);

      if (overlay) {
        overlay.addEventListener('click', function(e) {
          e.preventDefault();
          closeDrawer();
        });
      }

      closeBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          closeDrawer();
        });
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      });

      // 自定义搜索逻辑：在左侧抽屉内通过 AJAX 渲染结果列表
      const form = drawer.querySelector('[data-mt-search-form]');
      const input = drawer.querySelector('.mt-mega-header__search-input');
      const resultsContainer = drawer.querySelector('[data-mt-search-results]');

      if (form && input && resultsContainer) {
        const resetBtn = form.querySelector('.reset__button');
        const hasPredictive =
          window.routes && window.routes.predictive_search_url;

        // 无预测搜索时，至少要保证清除按钮能正常显示/隐藏
        if (!hasPredictive) {
          input.addEventListener('input', function (e) {
            const value = e.target.value || '';

            if (resetBtn) {
              if (value.trim().length) {
                resetBtn.classList.remove('hidden');
              } else {
                resetBtn.classList.add('hidden');
              }
            }
          });

          if (resetBtn) {
            resetBtn.addEventListener('click', function () {
              setTimeout(function () {
                input.value = '';
                resetBtn.classList.add('hidden');
              }, 0);
            });
          }

          return;
        }

        // 以下是开启预测搜索时的逻辑：简单防抖，避免每个按键都发请求
        function debounce(fn, delay) {
          let timer;
          return function () {
            const args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
              fn.apply(null, args);
            }, delay);
          };
        }

        function getSearchResultsPageUrl(term) {
          const base =
            (window.routes && window.routes.search_url) ||
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.search_url) ||
            '/search';
          const path = base.split('?')[0] || '/search';
          return path + '?q=' + encodeURIComponent(term || '');
        }

        function renderSearchLink(term) {
          const safeTerm = escapeHtml(term);
          const url = getSearchResultsPageUrl(term);

          const html =
            '<div class="mt-mega-header__search-results-heading" aria-hidden="true"><span>Products</span></div>' +
            '<ul class="mt-mega-header__search-results-list">' +
            '<li class="mt-mega-header__search-results-item">' +
            '<a href="' +
            url +
            '" class="mt-mega-header__search-results-link mt-cursor-circle">' +
            '<span class="mt-mega-header__search-results-title">Search for &ldquo;' +
            safeTerm +
            '&rdquo;</span>' +
            '</a>' +
            '</li>' +
            '</ul>';

          resultsContainer.innerHTML = html;
        }

        function renderResultsList(items, term) {
          if (!items.length) {
            // 没有预测结果时，至少提供一个“搜索 xxx”链接
            renderSearchLink(term);
            return;
          }

          var searchPageUrl = getSearchResultsPageUrl(term);
          var listHtml =
            '<div class="mt-mega-header__search-results-heading" aria-hidden="true"><span>Products</span></div>' +
            '<ul class="mt-mega-header__search-results-list">' +
            items
              .map(function (item) {
                var title = escapeHtml(item.title || '');
                var url = item.url || searchPageUrl;
                var image = item.image || '';
                var imageHtml = image
                  ? '<span class="mt-mega-header__search-results-thumb"><img src="' +
                    image +
                    '" alt="' +
                    title +
                    '"></span>'
                  : '<span class="mt-mega-header__search-results-thumb mt-mega-header__search-results-thumb--placeholder"></span>';
                return (
                  '<li class="mt-mega-header__search-results-item">' +
                  '<a href="' +
                  url +
                  '" class="mt-mega-header__search-results-link mt-cursor-circle">' +
                  imageHtml +
                  '<span class="mt-mega-header__search-results-title">' +
                  title +
                  '</span>' +
                  '</a>' +
                  '</li>'
                );
              })
              .join('') +
            '</ul>';

          console.log('[MtCustomHeader Search] renderResultsList', { count: items.length });
          resultsContainer.innerHTML = listHtml;
        }

        function renderLoading() {
          console.log('[MtCustomHeader Search] loading');
          resultsContainer.innerHTML = '<div class="mt-mega-header__search-results-loading">Loading...</div>';
        }

        function escapeHtml(str) {
          return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
        }

        function renderEmpty(term) {
          if (!term) {
            console.log('[MtCustomHeader Search] empty term, clear results');
            resultsContainer.innerHTML = '';
            return;
          }
          const safeTerm = escapeHtml(term);
          resultsContainer.innerHTML =
            '<div class="mt-mega-header__search-results-empty">No results for "<span>' +
            safeTerm +
            '</span>"</div>';
        }

        const performSearch = debounce(function (term) {
          const query = term.trim();
          console.log('[MtCustomHeader Search] performSearch', { term, query });
          if (!query.length) {
            renderEmpty('');
            return;
          }

          renderLoading();

          const url =
            window.routes.predictive_search_url +
            '?q=' +
            encodeURIComponent(query) +
            '&resources[type]=product,article,collection' +
            '&resources[limit]=10' +
            '&resources[options[unavailable_products]]=last' +
            '&resources[options[fields]]=title,body,product_type,variants.title,variants.sku,vendor' +
            '&section_id=predictive-search';

          console.log('[MtCustomHeader Search] request url', url);

          fetch(url)
            .then(function (response) {
              console.log('[MtCustomHeader Search] response', { ok: response.ok, status: response.status });
              if (!response.ok) throw new Error('Search request failed: ' + response.status);
              return response.text();
            })
            .then(function (text) {
              console.log('[MtCustomHeader Search] response text length', text.length);
              var parsed = new DOMParser().parseFromString(text, 'text/html');
              var wrapper = parsed.querySelector('#predictive-search-results');
              console.log('[MtCustomHeader Search] found wrapper?', !!wrapper);

              if (!wrapper) {
                renderEmpty(query);
                return;
              }

              var anchors = wrapper.querySelectorAll('.predictive-search__item');
              var items = Array.prototype.map.call(anchors, function (a) {
                var img = a.querySelector('img');
                var imgSrc = img && (img.getAttribute('src') || img.getAttribute('data-src'));
                return {
                  title: a.textContent.trim(),
                  url: a.getAttribute('href'),
                  image: imgSrc,
                };
              }).filter(function (item) {
                return item.title;
              });

              console.log('[MtCustomHeader Search] extracted items', { count: items.length });

              renderResultsList(items, query);
            })
            .catch(function (error) {
              console.error('[MtCustomHeader Search] request failed', error);
              renderEmpty(query);
            });
        }, 300);

        input.addEventListener('input', function (e) {
          const value = e.target.value || '';

          if (resetBtn) {
            if (value.trim().length) {
              resetBtn.classList.remove('hidden');
            } else {
              resetBtn.classList.add('hidden');
            }
          }

          performSearch(value);
        });

        if (resetBtn) {
          resetBtn.addEventListener('click', function () {
            // 等待浏览器重置 input 值后再更新结果
            setTimeout(function () {
              input.value = '';
              resetBtn.classList.add('hidden');
              renderEmpty('');
            }, 0);
          });
        }

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          performSearch(input.value || '');
        });
      }
    });
  }

  function initCustomHeaderScroll() {
    const header = document.querySelector('.mt-mega-header');
    if (!header) return;

    function isCustomHeaderMobileViewport() {
      return window.matchMedia('(max-width: 1023px)').matches;
    }

    // 首页与非首页区分：只有首页需要“透明 -> 滚动后变白底”效果
    const isHomeHeader = header.classList.contains('mt-mega-header--home');
    if (!isHomeHeader) {
      // 非首页：始终保持 solid 状态（白底黑字），不做透明切换
      header.classList.add('mt-mega-header--solid');
    }

    const headerSpacer = header.parentElement
      ? header.parentElement.querySelector('.mt-mega-header__spacer')
      : null;

    function syncHeaderSpacer() {
      if (!headerSpacer || isHomeHeader) return;
      if (isCustomHeaderMobileViewport() || !header.classList.contains('is-header-pinned')) {
        headerSpacer.style.height = '';
        header.style.removeProperty('--mt-header-spacer-height');
        return;
      }
      const height = header.offsetHeight + 'px';
      headerSpacer.style.height = height;
      header.style.setProperty('--mt-header-spacer-height', height);
    }

    function setPinned(pinned) {
      if (isHomeHeader) return;
      if (pinned) {
        // 先按文档流高度写入占位，再切 fixed，避免内容上跳/被挡
        if (!header.classList.contains('is-header-pinned') && headerSpacer && !isCustomHeaderMobileViewport()) {
          const height = header.offsetHeight + 'px';
          headerSpacer.style.height = height;
          header.style.setProperty('--mt-header-spacer-height', height);
        }
        header.classList.add('is-header-pinned');
        syncHeaderSpacer();
      } else {
        header.classList.remove('is-header-pinned');
        syncHeaderSpacer();
      }
    }

    syncHeaderSpacer();

    // 移动端：头部为文档流占位，关闭滚动隐藏/显现，避免与 CSS 不一致
    if (isCustomHeaderMobileViewport()) {
      header.classList.remove('header-hidden');
      setPinned(false);
    }

    // 获取滚动行为配置
    const scrollBehavior = header.getAttribute('data-scroll-behavior') || 'hide-on-scroll-down';
    
    // 如果配置为 'hide-on-scroll-down-only'，需要跟踪是否已经隐藏过
    let isPermanentlyHidden = false;

    let lastScrollY = window.scrollY;
    let ticking = false;

    // 页面加载时检查滚动位置
    // 如果配置为 'hide-on-scroll-down-only' 且页面不在顶部，则隐藏导航栏
    if (scrollBehavior === 'hide-on-scroll-down-only') {
      const currentScrollY = window.scrollY;
      if (isCustomHeaderMobileViewport()) {
        header.classList.remove('header-hidden');
        setPinned(false);
        isPermanentlyHidden = false;
      } else if (currentScrollY > 50) {
        // 页面不在顶部，隐藏导航栏
        setPinned(true);
        header.classList.add('header-hidden');
        isPermanentlyHidden = true;
      } else {
        // 页面在顶部，显示导航栏（非首页走文档流占位）
        header.classList.remove('header-hidden');
        setPinned(false);
        isPermanentlyHidden = false;
      }
    }

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (isCustomHeaderMobileViewport()) {
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      if (scrollBehavior === 'hide-on-scroll-down') {
        // 模式1：下滑时消失，上滑时显示
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
          // 向下滚动：非首页先 pinned 再隐藏，保留占位；首页仅隐藏
          if (!isHomeHeader) setPinned(true);
          header.classList.add('header-hidden');
        } else if (currentScrollY < lastScrollY) {
          // 向上滚动：显示导航栏
          if (!isHomeHeader) {
            if (currentScrollY > 100) {
              setPinned(true);
              header.classList.remove('header-hidden');
            } else {
              header.classList.remove('header-hidden');
              setPinned(false);
            }
          } else {
            header.classList.remove('header-hidden');
            if (currentScrollY > 100) {
              header.classList.add('mt-mega-header--solid');
            } else {
              header.classList.remove('mt-mega-header--solid');
            }
          }
        }

        // 回到顶部附近：首页恢复透明；非首页恢复文档流占位
        if (currentScrollY <= 100) {
          if (isHomeHeader) {
            header.classList.remove('mt-mega-header--solid');
          } else {
            header.classList.remove('header-hidden');
            setPinned(false);
          }
        }
      } else if (scrollBehavior === 'hide-on-scroll-down-only') {
        // 模式2：下滑时消失，上滑时不显示（除非回到顶部）
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
          if (!isHomeHeader) setPinned(true);
          header.classList.add('header-hidden');
          isPermanentlyHidden = true;
        } else if (currentScrollY < lastScrollY) {
          // 只有在页面顶部附近时才重新显示
          if (currentScrollY <= 50) {
            header.classList.remove('header-hidden');
            if (isHomeHeader) {
              header.classList.remove('mt-mega-header--solid');
            } else {
              setPinned(false);
            }
            isPermanentlyHidden = false;
          }
        }
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    // 使用 requestAnimationFrame 优化滚动性能
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener(
      'resize',
      function () {
        if (isCustomHeaderMobileViewport()) {
          header.classList.remove('header-hidden');
          setPinned(false);
        } else {
          syncHeaderSpacer();
        }
      },
      { passive: true }
    );
  }

  function initTitlesImages() {
    const containers = document.querySelectorAll('[data-titles-images]');
    containers.forEach(function(container) {
      const triggers = container.querySelectorAll('[data-titles-images-trigger]');
      const panels = container.querySelectorAll('[data-titles-images-panel]');
      if (!triggers.length || !panels.length) return;

      function showIndex(index) {
        triggers.forEach(function(t) {
          t.classList.toggle('is-active', t.getAttribute('data-index') === String(index));
        });
        panels.forEach(function(p) {
          p.classList.toggle('is-active', p.getAttribute('data-index') === String(index));
        });
      }

      triggers.forEach(function(trigger) {
        const index = trigger.getAttribute('data-index');
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          showIndex(index);
        });
      });
    });
  }

  function initLanguageDrawer() {
    const headers = document.querySelectorAll('[id^="MtCustomHeader-"]');
    headers.forEach((header) => {
      const langButton = header.querySelector('.mt-mega-header__action-btn--language');
      const drawer = header.querySelector('[data-language-drawer]');
      if (!langButton || !drawer) return;

      const panel = drawer.querySelector('.mt-mega-header__language-drawer-panel');
      const closeTargets = drawer.querySelectorAll('[data-language-drawer-close]');
      if (!panel) return;

      let lastFocusedElement = null;
      let onDocumentPointerDown = null;

      function openDrawer() {
        if (drawer.classList.contains('is-open')) return;
        lastFocusedElement = document.activeElement;
        drawer.classList.add('is-open');
        drawer.hidden = false;
        langButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');

        // 点击弹窗外空白处关闭
        if (!onDocumentPointerDown) {
          onDocumentPointerDown = function (event) {
            if (!drawer.classList.contains('is-open')) return;
            const target = event.target;
            if (!target) return;
            if (langButton.contains(target)) return;
            if (panel && panel.contains(target)) return;
            if (drawer.contains(target) && target !== document.documentElement && target !== document.body) {
              return;
            }
            closeDrawer();
          };
          document.addEventListener('pointerdown', onDocumentPointerDown, true);
        }
      }

      function closeDrawer() {
        if (!drawer.classList.contains('is-open')) return;
        drawer.classList.remove('is-open');
        drawer.hidden = true;
        langButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');
        if (onDocumentPointerDown) {
          document.removeEventListener('pointerdown', onDocumentPointerDown, true);
          onDocumentPointerDown = null;
        }
        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        } else {
          langButton.focus();
        }
      }

      langButton.addEventListener('click', (event) => {
        event.preventDefault();
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });

      closeTargets.forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          closeDrawer();
        });
      });

      drawer.addEventListener('click', (event) => {
        if (event.target.classList.contains('mt-mega-header__language-drawer-overlay')) {
          closeDrawer();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      });

    });
  }

  function initMobileLanguageToggle() {
    const headers = document.querySelectorAll('[id^="MtCustomHeader-"]');
    headers.forEach((header) => {
      const mobileToggle = header.querySelector('[data-mobile-language-toggle]');
      const panel = header.querySelector('[data-mobile-language-panel]');
      const mobileNav = header.querySelector('.mt-mega-header__mobile-nav');
      const mobileHeader = header.querySelector('.mt-mega-header__mobile-menu-header');
      if (!mobileToggle || !panel) return;

      mobileToggle.addEventListener('click', (event) => {
        if (window.innerWidth >= 1024) return; // 仅移动端/平板生效
        event.preventDefault();
        const isHidden = panel.hasAttribute('hidden');
        if (isHidden) {
          panel.removeAttribute('hidden');
          mobileToggle.setAttribute('aria-expanded', 'true');
        } else {
          panel.setAttribute('hidden', '');
          mobileToggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCustomHeaderScroll();
      initCustomHeaderSearch();
      initTitlesImages();
      initLanguageDrawer();
      initMobileLanguageToggle();
    });
  } else {
    initCustomHeaderScroll();
    initCustomHeaderSearch();
    initTitlesImages();
    initLanguageDrawer();
    initMobileLanguageToggle();
  }

  // 页面完全加载后再次检查（处理浏览器恢复滚动位置的情况）
  window.addEventListener('load', function() {
    const header = document.querySelector('.mt-mega-header');
    if (!header) return;

    const isHome = header.classList.contains('mt-mega-header--home');
    const mobile = window.matchMedia('(max-width: 1023px)').matches;
    const spacer = header.parentElement
      ? header.parentElement.querySelector('.mt-mega-header__spacer')
      : null;
    const currentScrollY = window.scrollY;
    const scrollBehavior = header.getAttribute('data-scroll-behavior') || 'hide-on-scroll-down';

    if (scrollBehavior === 'hide-on-scroll-down-only') {
      if (mobile) {
        header.classList.remove('header-hidden', 'is-header-pinned');
      } else if (currentScrollY > 50) {
        if (!isHome) header.classList.add('is-header-pinned');
        header.classList.add('header-hidden');
      } else {
        header.classList.remove('header-hidden', 'is-header-pinned');
      }
    } else if (!isHome && !mobile) {
      // 非首页：恢复滚动位置时，仅在离开顶部后保持 pinned 能力
      if (currentScrollY > 100) {
        header.classList.add('is-header-pinned', 'header-hidden');
      } else {
        header.classList.remove('header-hidden', 'is-header-pinned');
      }
    }

    if (spacer && !isHome) {
      if (mobile || !header.classList.contains('is-header-pinned')) {
        spacer.style.height = '';
        header.style.removeProperty('--mt-header-spacer-height');
      } else {
        const height = header.offsetHeight + 'px';
        spacer.style.height = height;
        header.style.setProperty('--mt-header-spacer-height', height);
      }
    }

    // Search & Filter Pro 产品卡片 & GF 过滤控件：自动添加 mt-cursor-circle 类
    try {
      function enhanceInteractiveElements(root) {
        if (!root || !root.querySelectorAll) return;
        var selectors = [
          '.spf-product-card',
          '.spf-product-card__left',
          '.spf-product-card__template-1',
          // GF filter options: 鼠标停在 checkbox 圆点上时也能命中 mt-cursor-circle
          '#gf-tree a',
          '#gf-tree .gf-label',
          '.gf-option-box a',
          '.gf-option-box .gf-Checkbox',
          '.gf-option-block .gf-label',
          '.gf-block-title',
          '.gf-filter-selection',
          // GF pagination page numbers
          '#gf_pagination_wrap .pagination > span:not(.prev):not(.next) > a',
          '#gf_pagination_wrap .pagination > span .page'
        ];
        selectors.forEach(function(selector) {
          root.querySelectorAll(selector).forEach(function(el) {
            el.classList.add('mt-cursor-circle');
          });
        });

        // GF pagination arrows：使用 mt-product-display-cursor（跟随鼠标箭头），这里仅确保不被圆圈光标覆盖
        root
          .querySelectorAll('#gf_pagination_wrap .pagination span.prev > a.gspf-page, #gf_pagination_wrap .pagination span.next > a.gspf-page')
          .forEach(function(el) {
            el.classList.remove('mt-cursor-circle');
          });
      }

      // 初次运行
      enhanceInteractiveElements(document);

      // 监听后续 AJAX 渲染
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              enhanceInteractiveElements(node);
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } catch (e) {
      console.error('[MtCustomHeader] Failed to enhance interactive elements', e);
    }
  });
})();
